import React, { FC } from 'react'
import QRCode from 'qrcode.react'
import { CloseIcon, TickIcon, CaretRightIcon } from '@okcredit/web-lib'
import { THEME } from 'components/theme'
import Confetti from 'components/Confetti'
import { ITranslate } from 'shared/constants'
import { formatCurrency } from 'utils/formatCurrency'
import LeftMobile from 'pages/SubscriptionBlockPage/assets/left_mobile.png'
import RightMobile from 'pages/SubscriptionBlockPage/assets/right_mobile.png'
import { MyPlanStyles } from './MyPlan.styles'

interface PaymentModalProps {
  loading: boolean
  error: string | null
  qrCodeUrl: string | null
  payableAmount: number
  planName: string
  isComplete: boolean
  isFailed: boolean
  onClose: () => void
  translate: ITranslate
}

const PaymentModal: FC<PaymentModalProps> = ({
  loading,
  error,
  qrCodeUrl,
  payableAmount,
  planName,
  isComplete,
  isFailed,
  onClose,
  translate
}) => {
  const classes = MyPlanStyles()

  const renderBody = () => {
    if (loading) {
      return <div className={classes.payStateText}>{translate('dashboard:Loading')}…</div>
    }
    if (isComplete) {
      return (
        <div className={classes.successWrap}>
          <Confetti origin={{ x: 0.5, y: 0.27 }} />
          <div className={classes.successCircle}>
            <TickIcon size={40} fill={THEME.onBrand} />
          </div>
          <div className={classes.successTitle}>{translate('dashboard:PaymentSuccessful')}</div>
          <div className={classes.successSubtitle}>
            {planName
              ? translate('dashboard:PlanActivated', { plan: planName })
              : translate('dashboard:SubscriptionActivated')}
          </div>
          <button className={classes.successBtn} onClick={onClose}>
            {translate('dashboard:Done')}
          </button>
        </div>
      )
    }
    if (isFailed) {
      return (
        <div className={`${classes.payStateText} ${classes.payFailed}`}>
          {translate('dashboard:PaymentFailed')}
        </div>
      )
    }
    if (error) {
      return <div className={classes.payStateText}>{error}</div>
    }
    return (
      <div className={classes.payColumns}>
        <div className={classes.payCol}>
          <div className={classes.payHeading}>{translate('dashboard:ScanPayUpi')}</div>
          {qrCodeUrl ? (
            <div className={classes.qrBox}>
              <QRCode
                value={qrCodeUrl}
                size={220}
                bgColor="#ffffff"
                fgColor="#212121"
                level="L"
                includeMargin={false}
                renderAs="svg"
              />
            </div>
          ) : null}
          <div className={classes.payable}>
            {translate('dashboard:PayableAmount')}: <b>₹{formatCurrency(payableAmount)}</b>
          </div>
        </div>
        <div className={classes.payColDivider}>
          <span className={classes.payOrBadge}>{translate('dashboard:or')}</span>
        </div>
        <div className={classes.payCol}>
          <div className={classes.payHeading}>{translate('dashboard:OpenOkcApp')}</div>
          <div className={classes.phonesRow}>
            <div className={classes.phoneWrap}>
              <img src={LeftMobile} alt="" className={classes.phoneImg} />
              <span className={classes.phoneCaption}>{translate('dashboard:StepClickMyPlan')}</span>
            </div>
            <CaretRightIcon size={20} fill={THEME.brandDarkerGrey} />
            <div className={classes.phoneWrap}>
              <img src={RightMobile} alt="" className={classes.phoneImg} />
              <span className={classes.phoneCaption}>{translate('dashboard:StepBuyPlan')}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.overlay} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <button className={classes.closePill} onClick={onClose} aria-label="Close">
          <CloseIcon size={16} fill={THEME.brandDarkerGrey} />
          {translate('dashboard:Close')}
        </button>
        {renderBody()}
      </div>
    </div>
  )
}

export default PaymentModal
